import { useContext } from 'react'
import { ContextMenuContext } from './context-menu-context'
import { ContentContainer, List } from '../styled-components'
import PropTypes from 'prop-types'
import {
  contextMenuAlignOptions,
  contextMenuArrowAlignmentOptions,
  contextMenuSideOptions
} from '../constants'
import ContextMenuArrow from './context-menu-arrow'

const ContextMenuList = ({
  align = contextMenuAlignOptions.CENTER,
  side = contextMenuSideOptions.BOTTOM,
  sideXOffset = 0,
  sideYOffSet = 0,
  arrow = false,
  hideScrollbar = false,
  arrowAlignment = contextMenuArrowAlignmentOptions.CENTER,
  width = '250px',
  maxHeight = '300px',
  height = 'auto',
  children,
  ...props
}) => {
  const { isOpen } = useContext(ContextMenuContext)

  if (!isOpen) {
    return null
  }

  return (
    <List
      align={align}
      side={side}
      sideXOffset={sideXOffset}
      sideYOffSet={sideYOffSet}
      width={width}
      {...props}
    >
      <ContentContainer
        maxHeight={maxHeight}
        hideScrollbar={hideScrollbar}
        height={height}
      >
        {children}
      </ContentContainer>
      {arrow && (
        <ContextMenuArrow arrowAlignment={arrowAlignment} side={side} />
      )}
    </List>
  )
}

ContextMenuList.propTypes = {
  align: PropTypes.oneOf(Object.values(contextMenuAlignOptions)),
  side: PropTypes.oneOf(Object.values(contextMenuSideOptions)),
  sideXOffset: PropTypes.number,
  sideYOffset: PropTypes.number,
  arrow: PropTypes.bool,
  hideScrollbar: PropTypes.bool,
  arrowAlignment: PropTypes.oneOf(
    Object.values(contextMenuArrowAlignmentOptions)
  ),
  width: PropTypes.string
}

export default ContextMenuList
